module.exports = __webpack_public_path__ + "img/product20ap.ef2b358b.png";